import router from '@/router'
import axios from '../config/api'
import { deepCopy } from '@/utils/utils'
const campaignType = process.env.VUE_APP_CAMPAIGN_TYPE ?? 'BNN'

const state = () => ({
  products: [],
  additionalProduct: [],
  stocks: null,

  selectModel: null,
  selectColor: null,
  selectSKU: null,

  isError: false,
  isLoading: false,
  isLoaded: false,
  isIncoming: false,
})

// getters
const getters = {
  getModels: state => {
    return (
      state?.products?.map(product => {
        return {
          ...product,
          price: product.model?.[0]?.data?.[0]?.price ?? null,
        }
      }) ?? []
    )
  },

  getColors: state => state.selectModel?.model,

  getStorages: state => {
    return (
      state.selectColor?.data ?? state.selectModel?.model?.[0]?.data
    )
  },

  getSoldOut: state => {
    let countActive = 0
    for (const p of state?.products) {
      for (const m of p?.model) {
        for (const c of m?.data) {
          if (c.active === true) {
            countActive++
          }
        }
      }
    }
    return !(countActive > 0)

    // const active = state?.products[0]?.model[0]?.data?.filter(
    //   items => {
    //     return items.active
    //   },
    // )
    // return active?.length <= 0 ? true : false
  },

  getBundles: state => {
    const getStorages = getters.getStorages?.[0]
    const items =
      state.selectSKU?.bundle_product ?? getStorages?.bundle_product
    return items?.filter(
      item =>
        item.type !== 'warranty' &&
        item.type !== 'delivery' &&
        item.type !== 'express' &&
        item.type !== 'accessory_bundle',
    )
  },

  getFreebie: state => {
    const getStorages = getters.getStorages?.[0]
    const items =
      state.selectSKU?.bundle_product ?? getStorages?.bundle_product
    return items?.filter(item => item.type === 'free')
  },

  //  free_handraiser for campaign samsung
  getHandraiserFreebies: state => {
    const getStorages = getters.getStorages?.[0]
    const items =
      state.selectSKU?.bundle_product ?? getStorages?.bundle_product
    return items?.filter(item => item.type === 'free_handraiser')
  },

  getAdditionalProduct: state => {
    const { additionalProduct } = state
    let items = []
    additionalProduct.map(a => {
      a?.products?.map(i => items.push(i))
    })
    return items?.filter(
      item =>
        item.type !== 'warranty' &&
        item.type !== 'delivery' &&
        item.type !== 'express' &&
        item.type !== 'accessory_bundle',
    )
  },

  getBundleDelivery: state => {
    const items = state.selectSKU?.bundle_product || []
    return items.filter(
      item => item.type === 'delivery' || item.type === 'express',
    )
  },

  getAppleCare: state => {
    const items = state.selectSKU?.bundle_product || []
    return items?.filter(item => item.type === 'warranty')?.[0]
  },

  getAccessoryBundles: state => {
    const items = state.selectSKU?.bundle_product || []
    return items?.filter(item => item.type === 'accessory_bundle')
  },
}

// actions
const actions = {
  async getStocks({ commit }, { slug }) {
    commit('setLoading', true)

    let endpoint = `/${campaignType}/stock?campaign=${slug}`

    const { admin_quota, code } = router.currentRoute.query

    // add code to query params if exists
    if (code) {
      endpoint += `&code=${code}`
    }

    // add admin_quota to query params if exists
    if (admin_quota) {
      endpoint += `&admin_quota=${
        admin_quota.toLowerCase() === 'true' ? 1 : 0
      }`
    }

    try {
      const result = await axios.get(endpoint)
      commit('setStocks', result.data.data)
      commit('setLoading', false)
    } catch {
      commit('setLoading', false)
      throw new Error('Error')
    }
  },

  async updateStatusSKU({ commit, state }) {
    const models = deepCopy(state.products)
    const additionalProducts = deepCopy(state.additionalProduct)
    if (models?.length === 0) {
      return
    }

    for (const model of models) {
      for (const color of model?.model) {
        for (const capacity of color?.data) {
          // update status sku of product
          capacity.active = state.stocks?.[capacity.sku] ?? false

          // update status sku of bundle
          for (const bundle of capacity?.bundle_product) {
            bundle.active = state.stocks?.[bundle.sku] ?? false
          }

          // update status sku of bundle
          for (const variant of capacity?.variant_product) {
            variant.active = state.stocks?.[variant.sku] ?? false
          }
        }
      }
    }

    for (const additional of additionalProducts) {
      for (const product of additional?.products) {
        product.active = state.stocks?.[product.sku] ?? false
      }
    }

    commit('setAdditionalProduct', additionalProducts)
    commit('setProducts', models)
  },

  getModel({ commit, state }, { slug, reload = false }) {
    if (state.products.length > 0 && reload === false) {
      return
    }

    let endpoint = `/v2/${campaignType}/products?campaign=${slug}`

    if (router.currentRoute.query.admin_quota) {
      let admin_quota =
        router.currentRoute.query.admin_quota.toLowerCase() === 'true'
          ? 1
          : 0
      endpoint = `${endpoint}&admin_quota=${admin_quota}`
    }

    commit('setLoading', true)
    return axios
      .get(endpoint)
      .then(response => {
        const mainProduct = response.data.data?.main_product

        // response.data.data?.main_product?.sort(
        //   (a, b) => {
        //     return b.model[0].data[0].price - a.model[0].data[0].price
        //   },
        // )

        for (const product of mainProduct) {
          let hasForceBundle = false
          let sumForceBundle = 0
          for (const model of product?.model) {
            for (const sku of model?.data) {
              if (sku.force_bundle === 1) {
                hasForceBundle = true
                sumForceBundle =
                  sku?.bundle_product?.reduce((acc, curr) => {
                    if (curr.type !== 'warranty') {
                      return +acc + +curr.price_ship
                    }
                    return +acc
                  }, 0) ?? 0
                break
              }
            }

            if (hasForceBundle) {
              break
            }
          }

          if (
            hasForceBundle &&
            product.model?.[0]?.data?.[0]?.price + sumForceBundle <
              product.model?.[0]?.data?.[0]?.price
          ) {
            product.start_price =
              product.model?.[0]?.data?.[0]?.price + sumForceBundle
          } else {
            product.start_price = product.model?.[0]?.data?.[0]?.price
          }
        }

        commit('setProducts', mainProduct)
        const additional_product = response.data.data?.additional_product.map(
          i => {
            return {
              ...i,
              products: i.products.map(item => {
                return {
                  ...item,
                  active: item?.active ?? false,
                }
              }),
            }
          },
        )
        commit('setAdditionalProduct', additional_product)

        commit('setIncoming', false)
        commit('setLoading', false)
      })
      .catch(err => {
        const data = err?.response?.data
        if (data?.message === 'incoming') {
          commit('setIncoming')
        } else {
          commit('setModelError')
        }
      })
  },

  selectModel({ commit }, model) {
    commit('setSelectModel', model)
    commit('setSelectColor', null)
    commit('setSelectSKU', null)
  },

  selectColor({ commit }, color) {
    commit('setSelectColor', color)
    commit('setSelectSKU', null)
  },

  selectSKU({ commit }, sku) {
    commit('setSelectSKU', sku)

    // add SKU to query params
    if (sku.sku && router.currentRoute.query.sku !== sku.sku) {
      router.push({
        query: {
          ...router.currentRoute.query,
          sku: sku.sku,
        },
      })
    }
  },

  reset({ commit, getters }) {
    const products = getters?.getModels
    if (products?.length === 0) {
      return false
    }
    // const active = state?.products[0]?.model[0]?.data?.filter(
    //   items => {
    //     return items.active
    //   },
    // )
    // const result = active.length > 0 ? active[0] : null

    commit('setSelectModel', products[0])
    commit('setSelectColor', null)
    commit('setSelectSKU', null)
    return true
  },
}

// mutations
const mutations = {
  setStocks(state, payload) {
    state.stocks = payload
  },

  setSelectModel(state, model) {
    state.selectModel = model
  },

  setSelectColor(state, color) {
    state.selectColor = color
  },

  setSelectSKU(state, sku) {
    state.selectSKU = sku
  },

  setLoading(state, val) {
    state.isLoading = val
    state.isError = false
  },

  setModelError(state) {
    state.isLoading = false
    state.isError = true
  },

  setIncoming(state, val = true) {
    state.isLoading = false
    state.isIncoming = val
  },

  setProducts(state, products) {
    const $tocode = val => {
      return val
        .toLowerCase()
        .split(' ')
        .join('-')
    }

    /**
     * create code from product name / color
     */

    const results = products.map(p => {
      p.code = $tocode(p.name)
      p.model = p.model.map(m => ({ ...m, code: $tocode(m.color) }))
      return p
    })

    state.products = results
    state.isLoaded = true
  },

  setAdditionalProduct(state, products) {
    state.additionalProduct = products.map(item => {
      return {
        ...item,
        // Sort by order key 0 to n for products in additional product
        products: item.products.sort((a, b) => a.order - b.order),
      }
    })

    state.isLoaded = true
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
